import React from 'react'

import { Modal } from 'antd'



export function showAbout(intl) {
	Modal.info({
		title: intl.formatMessage({id: 'about.title'}),
		content: (
			<div>
				<br />
				<div>{intl.formatMessage({id: 'footer.createdBy'})}</div>
				<a href="https://www.neoxis.be"><img src="/images/neoxis.png" alt="Neoxis logo" /></a><br />
				<br />
				Build: {process.env.NODE_ENV === 'production' ? process.env.REACT_APP_CI_BRANCH_TAG + '-' + (process.env.REACT_APP_CI_SHA || "").substr(0, 8) + '-' + process.env.REACT_APP_CI_ENVIRONMENT : process.env.NODE_ENV}<br />
				API: <a href="process.env.REACT_APP_API_URL">{process.env.REACT_APP_API_URL}</a><br />
				<br />
				&copy; 2020<br />
			</div>
			),
		className: "modal-about"
	});
}


// WEBPACK FOOTER //
// ./src/services/miscService.js